import { FC, useMemo, useState } from 'react';
import { Modal, ModalProps } from '../../../../../../../../components/modal/modal';
import { Tabs, TabType } from '../../../../../../../../components/tabs/tabs';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { ChartFilters, ChartInvalidData } from '../../use-dashboard-charts';
import { DashboardChartsWidgetTasksDuration } from './dasboard-charts-widget-tasks-duration/dasboard-charts-widget-tasks-duration';
import { DashboardChartsWidgetTasksFilters } from './dasboard-charts-widget-tasks-filters/dasboard-charts-widget-tasks-filters';
import s from './dashboard-charts-widget-modal.module.css';

export type DashboardChartsWidgetModalType = {
  name: string;
  invalidData?: ChartInvalidData;
  filters?: ChartFilters;
};

export const DashboardChartsWidgetModal: FC<ModalProps & DashboardChartsWidgetModalType> = (
  props,
) => {
  const { name, invalidData, filters, ...other } = props;
  const { t } = useLang();

  const tabs: TabType[] = useMemo(() => {
    const result: TabType[] = [];

    if (invalidData) {
      result.push({
        id: 'tasksDuration',
        label: t('Длительность задач'),
      });
    }

    if (filters) {
      result.push({
        id: 'filters',
        label: t('Фильтры'),
      });
    }

    return result;
  }, [filters, invalidData, t]);

  const [tab, setTab] = useState<TabType>(tabs[0]);

  return (
    <Modal className={s.feature} {...other} title={t('Настройки дашборда ') + name}>
      <Tabs tabs={tabs} activeTab={tab} onChange={setTab} />
      {filters && tab.id === 'filters' && <DashboardChartsWidgetTasksFilters {...filters} />}
      {invalidData && tab.id === 'tasksDuration' && (
        <DashboardChartsWidgetTasksDuration {...invalidData} />
      )}
    </Modal>
  );
};
